import { Browser } from "@capacitor/browser";
import { useReducer } from "react";
import type { CourseDrawerState, CourseDrawerAction } from "./CourseAccessDrawer";

// Initial state
const initialState: CourseDrawerState = {
	open: false,
	step: "go_to_login",
	selectedCourse: null,
};

const drawerReducer = (
	state: CourseDrawerState,
	action: CourseDrawerAction
): CourseDrawerState => {
	switch (action.type) {
		case "OPEN_DRAWER":
			return {
				open: true,
				step: "go_to_login",
				selectedCourse: action.payload,
			};
		case "CLOSE_DRAWER":
			return {
				...state,
				open: false,
			};
		case "SET_STEP":
			return {
				...state,
				step: action.payload,
			};
		default:
			return state;
	}
};

export const useCourseAccessDrawer = (websiteUrl = "https://akademialtca.pl/"): {
	state: CourseDrawerState;
	dispatch: React.Dispatch<CourseDrawerAction>;
	openAcademiaWebsite: () => Promise<void>;
} => {
	const [state, dispatch] = useReducer(drawerReducer, initialState);

	const openAcademiaWebsite = async (): Promise<void> => {
		await Browser.open({ url: websiteUrl });
	};

	return {
		state,
		dispatch,
		openAcademiaWebsite,
	};
};